// Additional polyfills
/* eslint-disable */
import "custom-event-polyfill";
import "url-polyfill";

import Vue from "vue";
import App from "./App";
import router from "./router";

import BootstrapVue from "bootstrap-vue";

import globals from "./globals";
import Popper from "popper.js";

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;

Vue.config.productionTip = false;

Vue.use(BootstrapVue);

// SYNCFUSION
import { registerLicense } from "@syncfusion/ej2-base";

// Registering Syncfusion license key
registerLicense(
  "Mgo+DSMBaFt9QHFqVkJrXVNbdV5dVGpAd0N3RGlcdlR1fUUmHVdTRHRcQlVhSH9SdEZnWXtfcHU=;ORg4AjUWIQA/Gnt2V1hhQlJAfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5bdERiWH1ddHRRRGRd;Mgo+DSMBMAY9C3t2V1hhQlJAfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5bdERiWH1ddHRRRWhd"
);

// SWEETALERT
import VueSweetalert2 from "vue-sweetalert2";

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);

// Global RTL flag
Vue.mixin({
  data: globals
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
